import React, { useState, useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import HomeNav from '../../Components/Navbar/NewNavbar';
import Loading1 from '../../Components/Loading/Loading1';
import AboutImg from "../../Images/Redesign/about2.png";

function About() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <div className="bg-white">
            <HomeNav />
            
            {/* Page Hero */}
            <section className="relative pt-32 pb-20 bg-secondary overflow-hidden">
                <div className="container-custom relative z-10">
                    <div className="max-w-3xl space-y-4">
                        <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Our Story</span>
                        <h1 className="text-5xl md:text-7xl font-heading font-black text-foreground leading-tight">
                            Elevating the Art <br /> 
                            <span className="text-primary italic">of Clean Living</span>
                        </h1>
                    </div>
                </div>
                {/* Decorative element */}
                <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 rounded-l-[100px] -z-0 translate-x-1/4"></div>
            </section>

            {/* Main Content */}
            <section className="section-padding">
                <div className="container-custom">
                    <div className="grid lg:grid-cols-2 gap-20 items-center">
                        <div className="relative fade-up">
                            <div className="absolute inset-0 bg-primary/10 rounded-[40px] rotate-3 -z-10"></div>
                            <img 
                                src={AboutImg} 
                                alt="Astra Clean" 
                                className="w-full h-[600px] object-cover rounded-[40px] shadow-2xl" 
                            />
                            <div className="absolute -bottom-10 -right-10 glass p-10 rounded-3xl shadow-2xl hidden md:block">
                                <p className="text-5xl font-black text-primary">100%</p>
                                <p className="text-xs font-bold uppercase tracking-widest text-muted-foreground mt-1">Satisfaction Guarantee</p>
                            </div>
                        </div>

                        <div className="space-y-8 fade-up text-lg text-foreground/80 leading-relaxed">
                            <p className="font-bold text-foreground text-2xl leading-snug">
                                Welcome to <span className="text-primary">Astra Clean</span>, where we believe a clean environment is the foundation of a happy and healthy life.
                            </p>
                            
                            <p>
                                We are a dedicated team of cleaning professionals committed to making your spaces shine, whether it's your home, office, or any other place that needs a thorough and reliable cleaning service.
                            </p>

                            <div className="space-y-4">
                                <h3 className="text-2xl font-black text-foreground pt-4">Tailored Solutions</h3>
                                <p>
                                    At Astra Clean, we offer a wide range of cleaning services tailored to meet your specific needs. From <strong>residential cleaning</strong> to keep your home spotless, to <strong>commercial cleaning</strong> for a productive workplace environment.
                                </p>
                            </div>

                            <div className="space-y-4">
                                <h3 className="text-2xl font-black text-foreground pt-4">Your Trust is Our Reward</h3>
                                <p>
                                    Your trust in us means everything. We are committed to building long-lasting relationships with our customers. We take pride in our work and strive to exceed your expectations with every service. 
                                </p>
                            </div>

                            <p className="italic text-primary font-medium text-xl border-l-4 border-primary pl-6 py-2 bg-primary/5 rounded-r-xl">
                                "Helping you create a cleaner, more comfortable space."
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values Section */}
            <section className="section-padding bg-secondary">
                <div className="container-custom">
                    <div className="grid md:grid-cols-3 gap-12">
                        <div className="card-premium p-10 text-center space-y-4">
                            <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h4 className="text-xl font-bold">Reliable Service</h4>
                            <p className="text-muted-foreground text-sm leading-relaxed">Punctual and consistent cleaning you can depend on every single time.</p>
                        </div>
                        <div className="card-premium p-10 text-center space-y-4">
                            <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h4 className="text-xl font-bold">Eco Friendly</h4>
                            <p className="text-muted-foreground text-sm leading-relaxed">Using green products that are safe for your family and the planet.</p>
                        </div>
                        <div className="card-premium p-10 text-center space-y-4">
                            <div className="w-16 h-16 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <h4 className="text-xl font-bold">Transparent Pricing</h4>
                            <p className="text-muted-foreground text-sm leading-relaxed">No hidden fees. Premium service at fair, upfront prices.</p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default About;

